import React, { useState } from 'react';
import { PrimaryButtonGreen, SecondaryButtonOutline } from '../ui/Buttons';
import { Loader2 } from 'lucide-react';
export function FiltersPanel() {
  const [brightness, setBrightness] = useState(50);
  const [contrast, setContrast] = useState(50);
  const [saturation, setSaturation] = useState(50);
  const [removeBg, setRemoveBg] = useState(false);
  return <div className="h-full flex flex-col" data-id="element-67">
      <div className="p-4 border-b border-gray-100" data-id="element-68">
        <h2 className="font-semibold text-gray-900" data-id="element-69">Filters</h2>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto flex-1" data-id="element-70">
        {/* Sliders */}
        <div className="space-y-4" data-id="element-71">
          <div data-id="element-72">
            <div className="flex justify-between mb-1" data-id="element-73">
              <label className="text-sm font-medium text-gray-700" data-id="element-74">
                Brightness
              </label>
              <span className="text-sm text-gray-500" data-id="element-75">{brightness}</span>
            </div>
            <input type="range" min="0" max="100" value={brightness} onChange={e => setBrightness(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600" data-id="element-76" />
          </div>

          <div data-id="element-77">
            <div className="flex justify-between mb-1" data-id="element-78">
              <label className="text-sm font-medium text-gray-700" data-id="element-79">
                Contrast
              </label>
              <span className="text-sm text-gray-500" data-id="element-80">{contrast}</span>
            </div>
            <input type="range" min="0" max="100" value={contrast} onChange={e => setContrast(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600" data-id="element-81" />
          </div>

          <div data-id="element-82">
            <div className="flex justify-between mb-1" data-id="element-83">
              <label className="text-sm font-medium text-gray-700" data-id="element-84">
                Saturation
              </label>
              <span className="text-sm text-gray-500" data-id="element-85">{saturation}</span>
            </div>
            <input type="range" min="0" max="100" value={saturation} onChange={e => setSaturation(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600" data-id="element-86" />
          </div>
        </div>

        {/* Background Removal */}
        <div className="pt-4 border-t border-gray-100" data-id="element-87">
          <div className="flex items-center justify-between mb-2" data-id="element-88">
            <span className="text-sm font-medium text-gray-700" data-id="element-89">
              Remove background
            </span>
            <button onClick={() => setRemoveBg(!removeBg)} className={`w-11 h-6 rounded-full transition-colors relative ${removeBg ? 'bg-violet-600' : 'bg-gray-200'}`} data-id="element-90">
              <div className={`w-4 h-4 bg-white rounded-full absolute top-1 transition-transform ${removeBg ? 'left-6' : 'left-1'}`} data-id="element-91" />
            </button>
          </div>

          {removeBg && <div className="flex items-center gap-2 text-sm text-violet-600 bg-violet-50 p-2 rounded-lg" data-id="element-92">
              <Loader2 size={14} className="animate-spin" data-id="element-93" />
              Processing background removal...
            </div>}
        </div>

        <div className="bg-blue-50 text-blue-700 p-3 rounded-lg text-xs" data-id="element-94">
          Tip: use background removal for raster images.
        </div>
      </div>

      <div className="p-4 border-t border-gray-100 flex gap-3" data-id="element-95">
        <PrimaryButtonGreen className="flex-1" data-id="element-96">Apply</PrimaryButtonGreen>
        <SecondaryButtonOutline className="flex-1" data-id="element-97">
          Reset
        </SecondaryButtonOutline>
      </div>
    </div>;
}